import {
    UPDATE_USER_ERROR,
    UPDATE_USER_START,
    UPDATE_USER_SUCCESS
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.user.update, action = {type: ''}) => {
    switch (action.type) {
        case UPDATE_USER_START:
            return {
                ...state,
                error: false,
                loading: true,
                success: false
            };
        case UPDATE_USER_SUCCESS:
            return {
                ...state,
                data: action.payload,
                loading: false,
                success: true
            };
        case UPDATE_USER_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
                success: false
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/userReducer/updateUserReducer.js